import { render, staticRenderFns } from "./Lead.vue?vue&type=template&id=22a323f9&scoped=true&"
import script from "./Lead.vue?vue&type=script&lang=js&"
export * from "./Lead.vue?vue&type=script&lang=js&"
import style0 from "./Lead.vue?vue&type=style&index=0&id=22a323f9&prod&scoped=true&lang=css&"
import style1 from "./Lead.vue?vue&type=style&index=1&id=22a323f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a323f9",
  null
  
)

export default component.exports